<template>
  <div class="college">
    <div class="page">
      <div class="page-name">
        <span>党旗引领</span>
        <el-button
          v-if="
            userInfo.roleCodes.includes('admin') ||
            power(userInfo.menuInfoList, 'create-course')
          "
          type="primary"
          size="small"
          class="ml-md"
          @click="toPathAdd"
          >创建课程</el-button
        >
      </div>
      <div class="search-list">
        <el-input
          placeholder="搜索名称"
          style="width: 250px"
          v-model="filterForm.keyword"
          class="search-input"
          size="small"
          clearable
        >
          <el-button
            size="small"
            slot="append"
            @click="search"
            icon="el-icon-search"
          ></el-button>
        </el-input>
        <!-- <el-select
          size="small"
          v-model="filterForm.resType"
          clearable
          placeholder="全部课程分类"
          class="ml-md"
        >
          <el-option
            v-for="item in list"
            :key="item.dicCode"
            :label="item.dicName"
            :value="item.dicCode"
          >
          </el-option>
        </el-select> -->
        <el-select
          size="small"
          v-model="filterForm.attachType"
          clearable
          placeholder="全部课程类型"
          class="ml-md"
        >
          <el-option
            v-for="item in typeList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>
      <div class="data-list">
        <el-row v-if="dataList.length > 0" :gutter="20">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="6"
            :xl="6"
            v-for="i in dataList"
            :key="i.id"
          >
            <div
              class="box-card"
              @click="toPathDetail(i.resCode)"
              @mouseover="mouseover(i)"
              @mouseleave="mouseleave"
            >
              <el-card :body-style="{ padding: '0px' }">
                <img
                  class="my-image"
                  :src="i.faceUrl + '?imageView2/2/h/150'"
                  alt=""
                />
                <div style="padding: 14px">
                  <h2>
                    {{ i.resTitle }}
                  </h2>
                  <div class="card-bottom">
                    <div class="card-bottom-left">
                      <span :class="convertType(i.resType)">{{
                        i.resTypeDesc
                      }}</span>
                      <!-- <el-tag type="success" class="type">{{
                          i.resTypeDesc
                        }}</el-tag> -->
                      <span class="view el-icon-view"> </span>
                      {{ i.viewCount }}
                      <span class="zan">
                        <i class="iconfont icon-zan1"></i>
                        <span class="praiseCount">{{
                          i.praiseCount || "0"
                        }}</span>
                      </span>
                    </div>
                    <div class="card-bottom-right">
                      <div v-if="i.attachType == 'video'">
                        <span class="el-icon-video-play icon"></span>
                        {{ formatSeconds(i.duration) }}
                      </div>
                      <div v-if="i.attachType == 'doc'">
                        <span class="el-icon-reading icon"></span>
                        {{ formatSeconds(i.duration) }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-card>
              <transition
                name="el-fade-in-linear"
                v-if="
                  i.createBy === userInfo.userId ||
                  userInfo.roleCodes.includes('admin')
                "
              >
                <i
                  v-show="curIdHover === i"
                  class="edit el-icon-edit"
                  @click.stop="toPathEdit(i.resCode)"
                ></i>
              </transition>
              <transition
                name="el-fade-in-linear"
                v-if="i.createBy === userInfo.userId"
              >
                <i
                  v-show="curIdHover === i"
                  class="del el-icon-delete"
                  @click.stop="delPop(i.id)"
                ></i>
              </transition>
            </div>
          </el-col>
        </el-row>
        <el-empty
          class="empty"
          :image-size="210"
          v-else
          description="暂无更多..."
        ></el-empty>
      </div>
      <pagination
        class="mb-md mr-md"
        slot="append"
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
      <!-- 删除的对话框 -->
      <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
    </div>
  </div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import { mapState } from "vuex";
import { postJson } from "../../http/fetch";
import Pagination from "../../components/Pagination.vue";
import { formatSeconds } from "@/utils";
import { power } from "../../utils";
export default {
  components: {
    Pagination,
    PopupDel,
  },
  name: "resource",
  data() {
    return {
      delVisible: false,
      pageLoading: false,
      filterForm: {
        resType: "",
        keyword: "",
        attachType: "",
      },
      list: [],
      dataList: [],
      typeList: [
        // { code: "", name: "全部类型" },
        { code: "doc", name: "文档" },
        // { code: "audio", name: "音频" },
        { code: "video", name: "视频" },
        // { code: "image", name: "图片" },
        // { code: "other", name: "其它格式" },
      ],
      pageObj: {
        current: 1,
        total: 0,
        size: 16,
        sizeList: [8, 16, 24, 32],
      },
      curIdHover: "",
      curId: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },

  methods: {
    power,
    formatSeconds,
    convertType(type) {
      let index = this.list?.findIndex((u) => u.dicCode == type);
      switch (index) {
        case 0:
          return "type type1";
        case 1:
          return "type type2";
        case 2:
          return "type type3";
        default:
          return "type ";
      }
    },
    init() {
      this.search();
    },
    toPathDetail(resCode) {
      this.$router.push({
        name: "resourceDetail",
        query: { resCode: resCode },
      });
    },
    delPop(id) {
      this.delVisible = true;
      this.curId = id;
    },
    async closePopupDel(status) {
      try {
        if (status) {
          await postJson("/resource/deleteResourceInfo", {
            id: this.curId,
            operatorId: this.userInfo.userId,
          });
          this.$message({
            message: "删除成功",
            type: "success",
            duration: 2000,
            offset: 150,
          });
          this.delVisible = false;
          this.search();
        } else {
          this.delVisible = false;
        }
      } catch (error) {}
    },
    toPathEdit(resCode) {
      this.$router.push({ name: "resourceEdit", query: { resCode: resCode } });
    },
    mouseover(id) {
      this.curIdHover = id;
    },
    mouseleave() {
      this.curIdHover = "";
    },
    search() {
      this.filterForm.current = 1;
      this.getData();
    },
    async getData() {
      this.pageLoading = true;
      let { records, total } = await postJson("/resource/getResourceInfoList", {
        schoolCode: this.userInfo.schoolCode,
        keyword: this.filterForm.keyword,
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        attachType: this.filterForm.attachType,
        resType: this.filterForm.resType,
      });
      this.dataList = records;
      this.pageObj.total = total;
      this.pageLoading = false;
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.current = 1;
      this.pageObj.size = pageSize;
      this.getData();
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage;
      this.getData();
    },
    toPathAdd() {
      this.$router.push({ name: "resourceEdit" });
    },
  },
  watch: {
    "filterForm.resType": function (values) {
      this.search();
    },
    "filterForm.attachType": function () {
      this.search();
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.$axios
      .get("/core/dic/getDictionaryList", {
        params: {
          dicType: "resType",
          schoolCode: this.userInfo.schoolCode,
        },
      })
      .then((res) => {
        this.list = res.data;
      });
  },
};
</script>

<style scoped lang="less">
.college {
  height: unset;
  @font-face {
    font-family: "iconfont";
    /* Project id 2622609 */
    src: url("//at.alicdn.com/t/font_2622609_63qtwpbi20s.woff2?t=1629870048673")
        format("woff2"),
      url("//at.alicdn.com/t/font_2622609_63qtwpbi20s.woff?t=1629870048673")
        format("woff"),
      url("//at.alicdn.com/t/font_2622609_63qtwpbi20s.ttf?t=1629870048673")
        format("truetype");
  }
  .icon-zan1:before {
    content: "\e600";
  }
  .search-list {
    margin-top: 16px;
    .search-input {
      width: 200px;
    }
  }
  .data-list {
    margin-top: 40px;
    .el-col {
      margin-bottom: 15px;
    }
    .empty {
      width: 210px;
      margin: 0 auto;
      text-align: center;
      font-size: 14px;
    }
    .box-card {
      position: relative;
      i {
        position: absolute;
        top: 12px;
        font-size: 14.5px;
        color: rgb(214, 214, 214);
        padding: 4px;
        border-radius: 50%;
        background-color: @hui;
      }
      .edit {
        right: 15px;
      }
      .edit:hover {
        color: @color;
      }
      .del {
        right: 43px;
      }
      .del:hover {
        color: @color;
      }
      h2 {
        line-height: 22px;
        font-size: 16px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        -webikit-box-orient: vertical;
        -webikit-line-clamp: 2;
        // height: 60px;
        max-height: 60px;
      }
      .card-bottom {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .card-bottom-left {
          display: flex;
          align-items: center;
        }
        .type {
          display: inline-block;
          margin-right: 10px;
          padding: 5px 3px;
          border-radius: 2px;
          font-size: 12px;
          line-height: 17px;
        }
        .type1 {
          color: #df7522;
          background: rgba(223, 117, 34, 0.1);
        }
        .type3 {
          color: #1584d8;
          background: rgba(21, 132, 216, 0.1);
        }
        .type2 {
          color: #222bdf;
          background: rgba(34, 43, 223, 0.1);
        }
        .view {
          font-size: 13px;
          cursor: pointer;
          margin-right: 6px;
        }
        .zan {
          position: relative;
          background-color: transparent;
          cursor: pointer;
          font-size: 13px;
          margin-left: 10px;
          .icon-zan1 {
            top: -15%;
            color: @hui;
            background-color: transparent;
          }
          .praiseCount {
            margin-left: 30px;
          }
        }
        .icon {
          font-size: 15px;
        }
      }

      .my-image {
        height: 150px;
        width: 100%;
      }
    }
  }
}
</style>